import { Text } from '@/components/atoms/Text';

import {
  ProductCategoryTitles,
  ProductCategoryTitlesProps,
} from '../comparisonElements/ProductCategory';
import {
  ProductFeatures,
  ProductFeaturesProps,
} from '../comparisonElements/ProductFeatureData';
import { useComparisonTableDropdownIndices } from '../utils';

export interface ComparisonFeaturesRow {
  titles?: ProductCategoryTitlesProps[];
  selectedData: Array<{
    productTypeFeatures?: ProductFeaturesProps[];
  } | null>;
}

const fallbackContent = <Text className='text-body-m text-base-black'>–</Text>;

export const ComparisonFeatureRows = ({
  titles,
  selectedData,
}: ComparisonFeaturesRow) => {
  const visibleItemsCount = selectedData.filter(Boolean).length;
  const dropdownIndices = useComparisonTableDropdownIndices();

  return (
    <div className='grid grid-cols-[160px_repeat(3,_minmax(200px,_1fr))] gap-y-3'>
      {titles?.map((title, rowIdx) => (
        <div key={`feature-${rowIdx}`} className='group contents'>
          {/* Title cell */}
          <div
            className={`text-body-m group-hover:bg-brand-100 group-hover:text-brand-900 flex rounded-l bg-gray-50 ${
              rowIdx % 2 === 0 ? 'bg-base-white' : ''
            }`}
          >
            <ProductCategoryTitles {...title} />
          </div>

          {/* Feature cells */}
          {dropdownIndices.map((i) => {
            const isDisabledColumn = visibleItemsCount < i;
            const isPlaceholder = i >= visibleItemsCount;

            const feature = selectedData[i]?.productTypeFeatures?.[rowIdx];

            let content: React.ReactNode = fallbackContent;

            // NOTE: rearanging the order breaks the render logic, keep the ordering the same
            if (i >= visibleItemsCount) content = fallbackContent;
            if (isPlaceholder) content = fallbackContent;

            if (feature) content = <ProductFeatures {...feature} />;

            if (isDisabledColumn) content = null;

            return (
              <div
                key={`feature-cell-${i}`}
                className={
                  'text-body-m group-hover:bg-brand-50 bg-base-white flex items-center rounded-r py-2 pl-12'
                }
              >
                {content}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};
